import { useNavigate } from "react-router-dom";
import { useUser } from "../gen/rbt/cloud/v1alpha1/user/user_rbt_react";
import { useAuthenticatedSession } from "../hooks/useAuthenticatedSession";
import { CreateOrganization } from "./CreateOrganization";

export function CreateOrganizationPage() {
  const session = useAuthenticatedSession();

  if (!session) {
    return <></>;
  }

  return <LoggedInCreateOrganizationPage userId={session.userId} />;
}

function LoggedInCreateOrganizationPage({ userId }: { userId: string }) {
  const { useGet } = useUser({ id: userId });
  const { response } = useGet();
  const navigate = useNavigate();

  if (response == undefined) {
    return <></>;
  }

  return (
    <CreateOrganization
      initialFlow="creating"
      onOrganizationCreated={() => navigate("/settings", { replace: true })}
      userEmail={response.userState?.email ?? ""}
    />
  );
}
